import React from 'react'
import './ProductMixed.less'
import { goIndex } from '@/assets/js/utils'

function Product ({ buriedPointEvent, data: { sublist = [], trackId, id, position, title } }) {
    return (
        <div className="product-mixed-wrap">
            <div className="product-mixed-inner" style={{
                width: `${320 / 75 * sublist.length}rem`
            }}>
                {sublist.map((item, index) => (
                    <div
                        className="product-mixed statistics-dom"
                        key={item.id}
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${trackId}-${item.title}`,
                                button_id: `${item.id}`,
                                button_order: `${index + 1}`,
                                area_order: position,
                                button_area: `${position}-${trackId}`
                            })
                            goIndex(item.url, trackId, item.keyword, item)
                        }}
                    >
                        <div className="businessLine">{item.businessLineName}</div>
                        <div className="productTrait">{item.productTrait}</div>
                        <div className="rate">{item.rate}<span>%</span></div>
                        <div className="rateName">{item.rateName}</div>
                        <div className="btnName">{item.btnName}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Product
